import React from '../../vendor/react';
import { X } from '../../vendor/lucide-react';
import type { ReactNode } from '../../vendor/react';
import { useEffect } from '../../vendor/react';
import { Button } from './Button';

export function Modal({
  open,
  title,
  children,
  onClose,
  size = 'default',
}: {
  open: boolean;
  title: string;
  children?: ReactNode;
  onClose: () => void;
  size?: 'default' | 'wide';
}) {
  useEffect(() => {
    if (!open) return;
    document.body.classList.add('nexo-modal-open');
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.classList.remove('nexo-modal-open');
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section className={`modal modal--${size}`} role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
        <header className="modal__header">
          <h2>{title}</h2>
          <Button variant="ghost" size="sm" aria-label="Cerrar modal" onClick={onClose} icon={<X size={18} />} />
        </header>
        <div className="modal__body">{children}</div>
      </section>
    </div>
  );
}
